export const paramsToString = (params: { [key: string]: any } = {}) => {
  const keys = Object.keys(params);

  if (!keys.length) return '';

  return keys.reduce((acc, paramKey, index) => {
    if (index !== 0) acc = acc + '&';
    acc = `${acc}${paramKey}=${params[paramKey]}`;

    return acc;
  }, '?');
};
